/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-announcement': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M12.834 4.666v2.333M5.979 3.207H3.967c-.98 0-1.47 0-1.844.191a1.75 1.75 0 0 0-.765.765c-.191.374-.191.864-.191 1.844v.7c0 .544 0 .816.089 1.03.118.286.345.513.631.632.215.088.486.088 1.03.088v2.48c0 .135 0 .203.006.26.054.554.492.992 1.046 1.046.057.006.125.006.26.006.136 0 .204 0 .26-.006a1.167 1.167 0 0 0 1.047-1.046c.006-.057.006-.125.006-.26v-2.48h.437c1.03 0 2.291.553 3.264 1.083.567.31.85.464 1.037.441a.552.552 0 0 0 .403-.24c.109-.152.109-.456.109-1.066V2.99c0-.609 0-.913-.109-1.066a.552.552 0 0 0-.403-.24c-.186-.022-.47.133-1.037.442-.973.53-2.233 1.082-3.264 1.082z" _stroke="#18283B" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
